import { ComponentType } from "react";
import { useFormatter } from "use-intl";
import { CompanyDocumentReadConfirmationConfirmDateFragment } from "gql/graphql";
import { Hidable, NotSpecified, Value } from "@/shared/value";

/**
 * Когда участник ознакомился с документом. Дата со временем в коротком цифровом
 * виде: она стоит второй строкой под статусом и не должна перебивать его длиной.
 */
export function CompanyDocumentReadConfirmationConfirmDate({
  data,
  whenEmpty: WhenEmpty = NotSpecified,
}: {
  data?: Hidable<CompanyDocumentReadConfirmationConfirmDateFragment>;
  whenEmpty?: ComponentType;
}) {
  const format = useFormatter();

  return (
    <Value data={data} whenEmpty={WhenEmpty}>
      {(confirmation) =>
        confirmation.confirmDate ? (
          <span>
            {format.dateTime(new Date(confirmation.confirmDate), {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        ) : (
          <WhenEmpty />
        )
      }
    </Value>
  );
}
